export default __webpack_public_path__ + "static/media/apexway.5a6ed314.png";